import React, { memo } from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import { CopyAllRounded, SaveAltRounded } from '@mui/icons-material';

interface Props {
  isMobile: boolean;
  onExport: () => void;
  onCopy: () => void;
}

export const TableToolbar = memo(function TableToolbar({
                                                         isMobile,
                                                         onExport,
                                                         onCopy,
                                                       }: Props) {
  return (
    <GridToolbarContainer
      sx={{
        p: 0,
        gap: isMobile ? 0 : '4px',
        '& .MuiButton-root': {
          background: '#ededed',
          padding: '2px 4px',
          fontSize: '11px',
          '& .MuiSvgIcon-root': {
            fontSize: '1rem !important',
          },
          '&:hover': {
            background: '#e3e3e3',
          },
        },
      }}
    >
      {!isMobile && (
        <>
          <Button startIcon={<SaveAltRounded />} onClick={onExport}>
            Export
          </Button>

          <Button startIcon={<CopyAllRounded />} onClick={onCopy}>
            Kijelölt sorok másolása
          </Button>
        </>
      )}

      <Box sx={{ flexGrow: 1 }} />
    </GridToolbarContainer>
  );
});